<template>
	<div name="tab13-popup" id="tab13-popup" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
		    <div class="modal-content">
		      <div class="modal-header header-popup">
	          <button type="button" class="close" data-dismiss="modal">&times;</button>
	          <h4 class="modal-title">{{ labels['STD_SKILSC']['10'] }} ()</h4>
	        </div>
	        <div class="modal-body">
            	<hrms-table :columns="tab13PopupColumn"
            				:data="detailTab13Popup" />
	        </div>
	    </div>
    </div>
	</div>
</template>

<script>
export default {
  name: 'tab13-popup',
  props: [ 'labels', 'detailTab13Popup', 'tab13PopupColumn' ]
}
</script>



// WEBPACK FOOTER //
// tab13Popup.vue?53f9edbc